import { render, staticRenderFns } from "./EditFotoTipeBarang.vue?vue&type=template&id=19a11532&"
import script from "./EditFotoTipeBarang.vue?vue&type=script&lang=js&"
export * from "./EditFotoTipeBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports